<mat-dialog-content [attr.data-testid]="testIds.dialogContentTestId">
  <div class="custom-div-dialog-icon">
    <mat-icon class="custom-dialog-icon" svgIcon="circle-warning"></mat-icon>
  </div>
  <h2 class="dialog-title" mat-dialog-title>{{ data.title }}</h2>
  <div>
    <p [innerHTML]="data.message" class="dialog-message">
      {{ data.message }}
    </p>
    <form [formGroup]="resetForm" class="dialog-input">
      <mat-form-field appearance="outline" class="input-field">
        <input
          [attr.data-testid]="testIds.dialogInputId"
          [type]="isPasswordVisible ? 'text' : 'password'"
          formControlName="password"
          matInput />
        <button (click)="togglePasswordVisibility()" mat-icon-button matSuffix>
          <mat-icon [svgIcon]="isPasswordVisible ? 'eye' : 'eye-slash'"></mat-icon>
        </button>
      </mat-form-field>
      <app-password-hint class="password-hint" [control]="resetForm.controls['password']"></app-password-hint>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions [attr.data-testid]="testIds.dialogActionTestId">
  <app-button (clicked)="onCancel()" [attr.data-testid]="testIds.cancelBtnId" [text]="data.cancelText"></app-button>
  <app-button
    (click)="generatePassword()"
    [attr.data-testid]="testIds.generateBtnId"
    text="Passwort vorschlagen"></app-button>
  <app-button
    (click)="onConfirm()"
    [attr.data-testid]="testIds.confirmBtnId"
    [isDisabled]="resetForm.invalid"
    [isPrimary]="true"
    [text]="data.confirmText">
  </app-button>
</mat-dialog-actions>
